import { StaticImage } from "gatsby-plugin-image"
import * as React from "react"

export const HowWeWork = () => {
  const [theme, setTheme] = React.useState<string | null>("")
  React.useEffect(() => {
    const interval = setInterval(() => {
      const currentTheme = localStorage.getItem("theme")
      setTheme(currentTheme)
    }, 500)

    return () => clearInterval(interval)
  }, [])
  return (
    <>
      <div className="container mx-auto">
        <div className="pt-10 mt-16">
          <div className="flex justify-between items-center mx-4 lg:mx-0">
            <p className="lg:text-5xl text-nowrap text-[16px] text-black font-semibold">
              How We <span className="text-[#7B68EC]">Works</span>
            </p>
            <p className="text-black lg:text-sm text-xs">
              Make your first step <br /> the only step
            </p>
          </div>
          <div className="mt-10">
            <div className="lg:p-2 p-1 w-full">
              {/* step-1 */}
              <div
                className={`flex lg:flex-row sm:flex-row flex-col w-full py-5 px-5 rounded-2xl h-full ${theme == "glassy" ? "bg-[#ffecd5]" : theme === "light" ? "bg-real-time-options" : theme === "dark" ? "bg-real-time-options" : "bg-[#ffecd5]"}`}
              >
                <div className="flex lg:w-[25%] sm:w-[25%] lg:flex-col sm:flex-col flex-row justify-between">
                  <div
                    className={`border w-fit rounded-full h-fit ${theme == "glassy" ? "border-black" : theme === "light" ? "border-black" : theme === "dark" ? "border-white" : "border-black"}`}
                  >
                    <p className="p-2 text-black text-sm">Step-001</p>
                  </div>
                  <div>
                    <p className="lg:text-3xl text-black font-semibold">
                      Consult
                    </p>
                  </div>
                </div>
                <div className="lg:w-[25%] sm:w-[25%] mx-auto">
                  {theme == "glassy" ? (
                    <div className="w-[70%] h-full">
                      <StaticImage
                        className="mx-3 w-full  h-full lg:mx-0"
                        src="./step-1.png"
                        alt="resource"
                        placeholder="blurred"
                        layout="fullWidth"
                      />
                    </div>
                  ) : theme === "light" ? (
                    <div className="w-[70%] h-full">
                      <StaticImage
                        className="mx-3 w-full lg:mx-0"
                        src="./step-1-light.png"
                        alt="resource"
                        placeholder="blurred"
                      />
                    </div>
                  ) : theme === "dark" ? (
                    <div className="w-[70%] h-full">
                      <StaticImage
                        className="mx-3 w-full lg:mx-0"
                        src="./step-1-dark.png"
                        alt="map"
                        placeholder="blurred"
                      />
                    </div>
                  ) : (
                    <div className="w-[70%] h-full">
                      <StaticImage
                        className="mx-3 w-full h-full lg:mx-0"
                        src="./step-1.png"
                        alt="map"
                        placeholder="blurred"
                      />
                    </div>
                  )}
                </div>
                <div className="lg:w-[25%] sm:w-[25%] flex items-center">
                  <p className="text-black text-xs text-justify">
                    At Visual Folio, we simplify the process to providing the
                    right talent for your project. Through a detailed
                    consultation, we understand your needs, match you with
                    expert resources, and ensure seamless collaboration. From
                    developers to designers, we provide skilled professionals
                    who align with your goals, work within your time zone, and
                    deliver top-quality results. Let’s build success together!{" "}
                  </p>
                </div>
              </div>
              {/* step-2 */}
              <div
                className={`flex lg:flex-row sm:flex-row flex-col mt-4 w-full py-5 px-5 rounded-2xl h-full ${theme == "glassy" ? "bg-[#ffecd5]" : theme === "light" ? "bg-real-time-options" : theme === "dark" ? "bg-real-time-options" : "bg-[#ffecd5]"}`}
              >
                <div className="flex lg:w-[25%] sm:w-[25%] lg:flex-col sm:flex-col flex-row justify-between">
                  <div
                    className={`border w-fit rounded-full h-fit ${theme == "glassy" ? "border-black" : theme === "light" ? "border-black" : theme === "dark" ? "border-white" : "border-black"}`}
                  >
                    <p className="p-2 text-black text-sm">Step-002</p>
                  </div>
                  <div>
                    <p className="lg:text-3xl text-nowrap text-black font-semibold">
                      Introduce the Resource <br />& Project Manager
                    </p>
                  </div>
                </div>
                <div className="lg:w-[25%] sm:w-[25%] mx-auto">
                  {theme == "glassy" ? (
                    <div className="w-[70%] h-full">
                      <StaticImage
                        className="mx-3 w-full  h-full lg:mx-0"
                        src="./step-2.png"
                        alt="resource"
                        placeholder="blurred"
                        layout="fullWidth"
                      />
                    </div>
                  ) : theme === "light" ? (
                    <div className="w-[70%] h-full">
                      <StaticImage
                        className="mx-3 w-full lg:mx-0"
                        src="./step-2-light.png"
                        alt="resource"
                        placeholder="blurred"
                      />
                    </div>
                  ) : theme === "dark" ? (
                    <div className="w-[70%] h-full">
                      <StaticImage
                        className="mx-3 w-full lg:mx-0"
                        src="./step-2-dark.png"
                        alt="map"
                        placeholder="blurred"
                      />
                    </div>
                  ) : (
                    <div className="w-[70%] h-full">
                      <StaticImage
                        className="mx-3 w-full h-full lg:mx-0"
                        src="./step-2.png"
                        alt="map"
                        placeholder="blurred"
                      />
                    </div>
                  )}
                </div>
                <div className="lg:w-[25%] sm:w-[25%] flex items-center">
                  <p className="text-black text-xs text-justify">
                    At Visual Folio, we ensure a smooth and efficient workflow
                    by assigning the right expert for your project. Once we
                    understand your requirements, we introduce you to a skilled
                    resource along with a dedicated project manager who oversees
                    progress, ensures clear communication, and keeps everything
                    on track. With seamless coordination and 24/7 availability,
                    we guarantee high-quality results tailored to your needs.
                    Let’s bring your vision to life!
                  </p>
                </div>
              </div>
              {/* step-3 */}
              <div
                className={`flex lg:flex-row sm:flex-row flex-col mt-4 w-full py-5 px-5 rounded-2xl h-full ${theme == "glassy" ? "bg-[#ffecd5]" : theme === "light" ? "bg-real-time-options" : theme === "dark" ? "bg-real-time-options" : "bg-[#ffecd5]"}`}
              >
                <div className="flex lg:w-[25%] sm:w-[25%] lg:flex-col sm:flex-col flex-row justify-between">
                  <div
                    className={`border w-fit rounded-full h-fit ${theme == "glassy" ? "border-black" : theme === "light" ? "border-black" : theme === "dark" ? "border-white" : "border-black"}`}
                  >
                    <p className="p-2 text-black text-sm">Step-003</p>
                  </div>
                  <div>
                    <p className="lg:text-3xl text-nowrap text-black font-semibold">
                      Start the contract
                      <br />& ready to work
                    </p>
                  </div>
                </div>
                <div className="lg:w-[25%] sm:w-[25%] mx-auto">
                  {theme == "glassy" ? (
                    <div className="w-[70%] h-full">
                      <StaticImage
                        className="mx-3 w-full  h-full lg:mx-0"
                        src="./step-3.png"
                        alt="resource"
                        placeholder="blurred"
                        layout="fullWidth"
                      />
                    </div>
                  ) : theme === "light" ? (
                    <div className="w-[70%] h-full">
                      <StaticImage
                        className="mx-3 w-full lg:mx-0"
                        src="./step-3-light.png"
                        alt="resource"
                        placeholder="blurred"
                      />
                    </div>
                  ) : theme === "dark" ? (
                    <div className="w-[70%] h-full">
                      <StaticImage
                        className="mx-3 w-full lg:mx-0"
                        src="./step-3-dark.png"
                        alt="map"
                        placeholder="blurred"
                      />
                    </div>
                  ) : (
                    <div className="w-[70%] h-full">
                      <StaticImage
                        className="mx-3 w-full h-full lg:mx-0"
                        src="./step-3.png"
                        alt="map"
                        placeholder="blurred"
                      />
                    </div>
                  )}
                </div>
                <div className="lg:w-[25%] sm:w-[25%] flex items-center">
                  <p className="text-black text-xs text-justify">
                    Once we’ve matched you with the right resource and project
                    manager, the next step is simple—finalize the contract and
                    kickstart the work! At Visual Folio, we ensure a smooth
                    onboarding process, transparent agreements, and immediate
                    project execution. Your dedicated expert is ready to
                    collaborate, deliver quality, and meet your goals
                    efficiently. Let’s build something amazing together!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
